<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
  metaInfo: {
    title: 'Small Business Inventory Management Software',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: 'Streamline Your Inventory with the Best Simple Management App for Small Businesses - Get Organized Today'
      }
    ]
  }
}
</script>
<style>
.v-main__wrap {
  background: #fafafa !important;
}
</style>
